//#region src/utils/commonModels/customerAddress.ts
var e = {
	BILLING: "BILLING",
	SHIPPING: "SHIPPING"
}, t = (t) => t?.find(({ purposes: t }) => t.includes(e.BILLING))?.address ?? null, n = (t) => t ? [{
	purposes: [e.BILLING],
	address: t
}] : [];
//#endregion
export { e as CUSTOMER_ADDRESS_PURPOSES, t as getBillingAddress, n as toBillingOnlyAddresses };

//# sourceMappingURL=index.js.map